const e = "naive-ui-style";
export {
  e as cssrAnchorMetaName
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/_mixins/common.js
// module id = 307
// module chunks = 41